import React from 'react';
import { BiBed, BiBath, BiArea } from 'react-icons/bi';
import { RiArrowRightLine, RiMapPin2Fill } from 'react-icons/ri';

const House = ({ house }) => {
    const { image, type, rentalType, address, bedrooms, bathrooms, surface, price } = house;

    return (
        <article className='h-full w-full overflow-hidden rounded-2xl border border-white/70 bg-white/80 shadow-[0_18px_60px_rgba(15,23,42,0.10)] backdrop-blur transition duration-300 group-hover:-translate-y-1 group-hover:shadow-[0_26px_80px_rgba(15,23,42,0.16)]'>
            <div className="relative h-[238px] overflow-hidden">
                <img className='h-full w-full object-cover transition duration-700 group-hover:scale-105' src={image} alt={address} />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-950/5 to-transparent" />
                <div className="absolute left-4 top-4 rounded-full bg-white/85 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-slate-800 backdrop-blur">
                    {rentalType}
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-sm font-semibold text-white/80">{type}</p>
                    <h3 className="text-2xl font-bold tracking-tight text-white">{address.split(",")[0]}</h3>
                </div>
            </div>
            <div className='p-5'>
                <div className='flex items-start gap-2 text-sm text-slate-500'>
                    <RiMapPin2Fill className="mt-0.5 flex-shrink-0 text-teal-700" />
                    <span>{address}</span>
                </div>
                <div className='mt-5 grid grid-cols-3 gap-2 border-y border-slate-200 py-4 text-slate-700'>
                    <div className='flex flex-col items-center gap-1'>
                        <div className='text-[22px] text-teal-700'><BiBed /></div>
                        <div className="text-sm font-bold">{bedrooms}</div>
                    </div>
                    <div className='flex flex-col items-center gap-1 border-x border-slate-200'>
                        <div className='text-[22px] text-teal-700'><BiBath /></div>
                        <div className="text-sm font-bold">{bathrooms}</div>
                    </div>
                    <div className='flex flex-col items-center gap-1'>
                        <div className='text-[22px] text-teal-700'><BiArea /></div>
                        <div className="text-sm font-bold">{surface}</div>
                    </div>
                </div>
                <div className="mt-5 flex items-center justify-between">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">From</p>
                        <p className="text-xl font-bold text-slate-950">${price}/week</p>
                    </div>
                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-slate-950 text-white transition duration-300 group-hover:bg-teal-700">
                        <RiArrowRightLine />
                    </span>
                </div>
            </div>
        </article>
    )
}

export default House;
